/*eslint-disable*/
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
/**
 * Token Provider implementation for connecting to a custom Azure Function endpoint.
 */
var MyAzTokenProvider = /** @class */ (function () {
    /**
     * Creates a new instance using configuration parameters.
     * @param azFunctionUrl - URL to Azure Function endpoint
     * @param user - User object with id and name ，特製可接受用 TMIDtoken
     */
    function MyAzTokenProvider(azFunctionUrl, user) {
        this.maxRetries = 3;
        this.retryDelay = 1000;
        this.azFunctionUrl = azFunctionUrl;
        this.user = { id: user.id, name: user.name, idToken: user.idToken };
    }
    MyAzTokenProvider.prototype.fetchOrdererToken = function (tenantId, documentId, refresh) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {};
                        return [4 /*yield*/, this.getToken(tenantId, documentId, refresh)];
                    case 1: 
                    // console.log("fetchOrdererToken", tenantId, documentId, refresh);
                    return [2 /*return*/, (_a.jwt = _b.sent(),
                            _a)];
                }
            });
        });
    };
    MyAzTokenProvider.prototype.fetchStorageToken = function (tenantId, documentId, refresh) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = {};
                        return [4 /*yield*/, this.getToken(tenantId, documentId, refresh)];
                    case 1: 
                    // console.log("fetchStorageToken", tenantId, documentId, refresh);
                    return [2 /*return*/, (_a.jwt = _b.sent(),
                            _a)];
                }
            });
        });
    };
    MyAzTokenProvider.prototype.getToken = function (tenantId_1, documentId_1) {
        return __awaiter(this, arguments, void 0, function (tenantId, documentId, refresh) {
            var cachedToken, cachedTokenExpiry, now, expiry, _loop_1, this_1, attempt, state_1;
            var _this = this;
            if (refresh === void 0) { refresh = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //檢查是否有有效快取的 Token，且docId 要有值
                        if (!refresh && documentId) {
                            cachedToken = localStorage.getItem("cachedFluidRelayToken");
                            cachedTokenExpiry = localStorage.getItem("cachedFluidRelayTokenExpiry");
                            if (cachedToken && cachedTokenExpiry) {
                                now = Math.floor(Date.now() / 1000);
                                expiry = parseInt(cachedTokenExpiry, 10);
                                // 如果 Token 沒有過期，直接返回
                                if (expiry > now) {
                                    return [2 /*return*/, cachedToken];
                                }
                                // 如果過期，清除快取
                                localStorage.removeItem("cachedFluidRelayToken");
                                localStorage.removeItem("cachedFluidRelayTokenExpiry");
                            }
                        }
                        _loop_1 = function (attempt) {
                            var response, token, now, expiry, error_1;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 6]);
                                        return [4 /*yield*/, axios_1.default.post(this_1.azFunctionUrl, {
                                                id_token: this_1.user.idToken,
                                                id: this_1.user.id,
                                                name: this_1.user.name,
                                                documentId: documentId,
                                                scopes: ["doc:read", "doc:write", "summary:write"],
                                                lifeTime: 3600,
                                            })];
                                    case 1:
                                        response = _b.sent();
                                        token = response.data;
                                        now = Math.floor(Date.now() / 1000);
                                        expiry = now + 3600;
                                        if (documentId) {
                                            // 儲存 Token 和過期時間
                                            localStorage.setItem("cachedFluidRelayToken", token);
                                            localStorage.setItem("cachedFluidRelayTokenExpiry", expiry.toString());
                                        }
                                        return [2 /*return*/, { value: token }];
                                    case 2:
                                        error_1 = _b.sent();
                                        // 重試
                                        console.warn("Attempt ".concat(attempt, " to fetch token failed."), error_1);
                                        if (!(attempt < this_1.maxRetries)) return [3 /*break*/, 4];
                                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, _this.retryDelay * attempt); })];
                                    case 3:
                                        _b.sent();
                                        return [3 /*break*/, 5];
                                    case 4: throw new Error("Failed to fetch token after multiple attempts.");
                                    case 5: return [3 /*break*/, 6];
                                    case 6: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        attempt = 1;
                        _a.label = 1;
                    case 1:
                        if (!(attempt <= this.maxRetries)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(attempt)];
                    case 2:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        _a.label = 3;
                    case 3:
                        attempt++;
                        return [3 /*break*/, 1];
                    case 4: throw new Error("Unexpected error in token retrieval.");
                }
            });
        });
    };
    return MyAzTokenProvider;
}());
exports.default = MyAzTokenProvider;
